import ListPickOrders from "../../../../components/@documents/pick_orders/ListPickOrders";

import {routeTypes} from "../../../../hooks/useSystemRoutes";

export default function PickOrdersPage() {

    return (
        <ListPickOrders
            routeType={routeTypes.admin}
        />
    )
}